import getImageUrl from './get-image-url'
import Breadcrumb from './Breadcrumb.jsx'
import PageHeader from './PageHeader.jsx'
import { useInView } from 'react-intersection-observer'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide'
import '@splidejs/splide/css/core'
import { Icon } from '@iconify/react'
import 'animate.css'
import { useMediaQuery } from 'react-responsive'
import ReactPlayer from 'react-player/youtube'
import { useEffect, useState } from 'react'
import apiFetch from '@wordpress/api-fetch'
import scrollIntoView from 'scroll-into-view-if-needed'
import { motion } from 'framer-motion'

const fadeInBottom = {
  hidden: {
    opacity: 0,
    y: 80,
  },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      y: {
        duration: 1.3,
        ease: [0.165, 0.84, 0.44, 1],
        delay: i || 0,
      },
      opacity: {
        duration: 0.3,
        delay: i || 0,
      },
    },
  }),
}

const data = [
  { photo: 'reason-for-choosing-step-1.png' },
  { photo: 'reason-for-choosing-step-2.png' },
  { photo: 'reason-for-choosing-step-3.png' },
  { photo: 'reason-for-choosing-step-4.png' },
  { photo: 'reason-for-choosing-step-5.png' },
  { photo: 'reason-for-choosing-step-6.png' },
  { photo: 'reason-for-choosing-step-7.png' },
]

const data_sp = [
  { photo: 'reason-for-choosing-step-sp-1.png' },
  { photo: 'reason-for-choosing-step-sp-2.png' },
  { photo: 'reason-for-choosing-step-sp-3.png' },
  { photo: 'reason-for-choosing-step-sp-4.png' },
  { photo: 'reason-for-choosing-step-sp-5.png' },
  { photo: 'reason-for-choosing-step-sp-6.png' },
  { photo: 'reason-for-choosing-step-sp-7.png' },
]

const scr = (node, block = 'start') => {
  scrollIntoView(node, {
    behavior: 'smooth',
    scrollMode: 'if-needed',
    block: block,
    inline: 'start',
  })
}

const Box1 = (props) => {
  const isPC = useMediaQuery({ query: '(min-width: 1024px)' })
  const is4K = useMediaQuery({ query: '(min-width: 2500px)' })

  const { ref, inView, entry } = useInView({
    triggerOnce: true,
    rootMargin: isPC ? '0px 10000px -20% 0px' : '0px 0px 0% 0px',
    threshold: isPC ? 1 : 0.75,
  })

  const Heading = () => {
    return (
      <>
        <img
          src={props.number}
          alt=""
          className={
            isPC
              ? 'w-[calc(46vw/19.2)] max-h-[min(calc(108vw/19.2),108px)] object-contain'
              : 'w-[calc(30vw/7.5)] max-h-[calc(70vw/7.5)] object-contain'
          }
        />
        <p className={isPC ? 'heading ml-[calc(50vw/19.2)]' : 'heading'}>{props.heading}</p>
        <style jsx>{`
          .heading,
          .paragrah {
            white-space: pre-wrap;
          }
          .heading {
            font-size: calc(45vw / 7.5);
            font-weight: bold;
            color: #f9d022;

            line-height: 1.2;
          }
          @media (min-width: 768px) {
            .heading {
              font-size: calc(18vw / 7.68);
              font-weight: bold;
              color: #f9d022;
            }
          }
          @media (min-width: 1024px) {
            .heading {
              font-size: calc(18vw / 10.24);
              font-weight: bold;
              color: #f9d022;
            }
          }
          @media (min-width: 1240px) {
            .heading {
              font-size: clamp(14px, calc(40vw / 19.2), 40px);
              font-weight: bold;
              color: #f9d022;
            }
          }
        `}</style>
      </>
    )
  }

  // ハッシュクエリを取得
  const hash = window.location.hash

  const animation = {
    opacity: 1,
    x: [2000, 0],
  }

  const second = 1

  const props_animation = hash
    ? {
        animate: animation,
        transition: {
          delay: 1.2,
          duration: second,
        },
      } // ハッシュクエリがある場合はanimateを使用
    : {
        whileInView: animation,
        viewport: {
          once: true,
          amount: 1,
        },
        transition: {
          duration: second,
        },
      } // ハッシュクエリがない場合はwhileInViewを使用

  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      {...props_animation}
      className={props.className}
    >
      <div
        className="box1"
        ref={ref}
        id={props.id}
      >
        <div
          className={
            isPC
              ? 'flex items-center pl-[88px] pr-3 py-[58px] relative'
              : 'relative pl-[calc(80vw/7.5)] pr-[calc(70vw/7.5)] py-[calc(30vw/7.5)]'
          }
        >
          <img
            src={getImageUrl('reason-for-choosing-kowashiro.png')}
            alt=""
            className={
              isPC
                ? 'absolute left-[-160px]'
                : 'absolute h-[calc(140vw/7.5)] left-[calc(-60vw/7.5)] top-[calc(10vw/7.5)]'
            }
          />
          {isPC ? (
            <Heading />
          ) : (
            <div className="flex items-center gap-[calc(15vw/7.5)]">
              <Heading />
            </div>
          )}
          <p className={isPC ? 'paragrah ml-[calc(60vw/19.2)]' : 'paragrah mt-[calc(40vw/7.5)]'}>
            {props.paragrah}
          </p>
        </div>
      </div>
      <style jsx>{`
        .box1 {
          margin-left: calc(84vw / 7.5);
          display: flex;
          align-items: center;
          background: transparent
            linear-gradient(
              115deg,
              #003475 0%,
              #003678 27%,
              #003e82 48%,
              #004b93 68%,
              #005daa 86%,
              #0070c2 100%
            )
            0% 0% no-repeat padding-box;
          will-change: transform;
        }
        .paragrah {
          white-space: pre-wrap;
        }
        .paragrah {
          font: normal normal normal min(16px, calc(35vw / 7.5)) Noto Sans JP;
          color: #ffffff;
        }
        @media (min-width: 1024px) {
          .box1 {
            margin-left: 0;
            max-width: 1628px;
            width: 100%;
            height: calc(326vw / 19.2);
            min-height: 262px;
            max-height: 326px;
            display: flex;
            align-items: center;
            background: transparent
              linear-gradient(
                115deg,
                #003475 0%,
                #003678 27%,
                #003e82 48%,
                #004b93 68%,
                #005daa 86%,
                #0070c2 100%
              )
              0% 0% no-repeat padding-box;
          }
          .heading,
          .paragrah {
            white-space: pre-wrap;
          }
          .heading {
            font-size: 40px;
            font-weight: bold;
            color: #f9d022;
          }
          .paragrah {
            font: normal normal normal clamp(13px, calc(24vw / 19.2), 24px) Noto Sans JP;
            color: #ffffff;
            padding-right: 1rem;
          }
        }
      `}</style>
    </motion.div>
  )
}

const ReasonForChoosing = () => {
  const isPC = useMediaQuery({ query: '(min-width: 1024px)' })
  const isXL = useMediaQuery({ query: '(min-width: 1240px)' })

  const [youtube, setYoutube] = useState('')

  useEffect(() => {
    const hash = window.location.hash
    if (hash) {
      const node = document.querySelector(hash)
      if (
        hash === '#reason-for-choosing-1' ||
        hash === '#reason-for-choosing-2' ||
        hash === '#reason-for-choosing-3'
      ) {
        setTimeout(() => {
          scr(node, 'center')
        }, 800)
      } else {
        setTimeout(() => {
          scr(node)
        }, 800)
      }
    }

    apiFetch({
      path: '/wp-json/myroutes/reason',
    }).then((res) => {
      setYoutube(res)
    })
  }, [])

  return (
    <>
      <div id="reason-for-choosing">
        <PageHeader
          title={'選ばれる理由'}
          image={getImageUrl('REASON-FOR-CHOOSING.png')}
        />
        <div className="content-area">
          <Breadcrumb
            current={'選ばれる理由'}
            site_url={import.meta.env.VITE_SITE_URL}
            items={[]}
          />
        </div>
        <div className="pt-[calc(90vw/7.5)] pb-[calc(152vw/7.5)] lg:pt-[114px] lg:pb-[230px]">
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          >
            <h2>選ばれる理由</h2>
          </motion.div>
          <div
            className={
              isPC
                ? 'mt-[100px] grid gap-y-[120px] overflow-hidden'
                : 'mt-[min(calc(100vw/7.5),50px)] grid gap-y-[120px] overflow-hidden'
            }
          >
            <Box1
              className="lg:ml-[170px]"
              number={getImageUrl('reason-for-choosing-num-1.png')}
              heading={`不動産経験者が\n皆様の立場で考える`}
              paragrah={`横浜総合建設の営業スタッフは大半が不動産経験者です。${
                isPC ? '\n' : '\n'
              }工事を依頼する立場を経験しており、解体工事の流れも分かっているからこそ${
                isPC ? '\n' : ''
              }「造ることを考えた解体工事」がご提供できるのです。${
                isPC ? '\n' : ''
              }また、お話しを聞かせていただければ、状況の把握もできますので、${
                isPC ? '\n' : ''
              }ストレスのないスムーズなやりとりが可能です。`}
              id="reason-for-choosing-1"
              first={true}
            />
            <Box1
              className="lg:ml-[170px]"
              number={getImageUrl('reason-for-choosing-num-2.png')}
              heading={`自社スタッフ・\n重機による\n安心自社施工`}
              paragrah={`自社スタッフと自社保有の重機を中心に解体工事を行っています。${
                isPC ? '\n' : ''
              }皆様と直接やり取りができるので、余計な中間マージンが発生しないだけではなく、${
                isPC ? '\n' : ''
              }作業や重機使用状況の確認など、他社とのやり取りが発生せず、皆様のご要求に対し、${
                isPC ? '\n' : ''
              }即座にお応えできるスムーズでフットワークの軽いフレキシブルな対応が可能です。`}
              id="reason-for-choosing-2"
            />
            <Box1
              className="lg:ml-[170px]"
              number={getImageUrl('reason-for-choosing-num-3.png')}
              heading={`ワンストップで\n素早く柔軟に対応`}
              paragrah={`スピーディーな解体工事をご提供するために心がけているのは、${
                isPC ? '\n' : ''
              }お客様のご要望への迅速なリアクション。${
                isPC ? '\n' : ''
              }見積もりから引き渡しまで、営業も兼任する現場監督がフレキシブルに${
                !isXL && isPC ? '\n' : ''
              }対応します。`}
              id="reason-for-choosing-3"
            />
          </div>
        </div>
        <div className="bg-[#F4FBFF] pt-[calc(134vw/7.5)] pb-[calc(150vw/7.5)] lg:pt-[200px] lg:pb-[152px]">
          <div className="content-area">
            <motion.div
              variants={fadeInBottom}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.5,
              }}
            >
              <h3>解体の流れ</h3>
            </motion.div>
            <ReactPlayer
              url={youtube && youtube}
              className="aspect-video mt-[min(calc(100vw/7.5),50px)] md:mt-[150px]"
              width={'100%'}
              height={'100%'}
            />
          </div>

          <Splide
            aria-label="工事写真"
            hasTrack={false}
            className="mt-[min(calc(100vw/7.5),50px)] md:mt-[150px]"
            options={{
              focus: 'center',
              fixedWidth: 1000,
              fixedHeight: 600,
              gap: '100px',
              trimSpace: false,
              type: 'loop',
              breakpoints: {
                767: {
                  fixedWidth: 'calc(543vw/7.5)',
                  fixedHeight: 'calc(326vw/7.5)',
                  gap: 'calc(54vw/7.5)',
                  type: 'loop',
                },
              },
            }}
          >
            <SplideTrack>
              {isPC
                ? data.map((item, index) => {
                    return (
                      <SplideSlide key={index}>
                        <img
                          src={getImageUrl(item.photo)}
                          alt=""
                        />
                      </SplideSlide>
                    )
                  })
                : data_sp.map((item, index) => {
                    return (
                      <SplideSlide key={index}>
                        <img
                          src={getImageUrl(item.photo)}
                          alt=""
                        />
                      </SplideSlide>
                    )
                  })}
            </SplideTrack>
            <div
              className={
                isPC
                  ? 'splide__arrows flex w-full max-w-[1000px] mx-auto justify-between absolute inset-0 my-auto h-[76px]'
                  : 'splide__arrows flex w-[calc(543vw/7.5)] mx-auto justify-between absolute inset-0 my-auto h-[42px]'
              }
            >
              <button
                className={
                  isPC
                    ? 'splide__arrow splide__arrow--prev arrow-btn ml-3 xl:-ml-10'
                    : 'splide__arrow splide__arrow--prev arrow-btn ml-[calc(-21vw/7.5)]'
                }
              >
                <Icon
                  icon="ep:arrow-up"
                  rotate={3}
                  className={isPC ? 'w-10 h-10' : 'w-[calc(28vw/7.5)] h-[calc(28vw/7.5)]'}
                />
              </button>
              <button
                className={
                  isPC
                    ? 'splide__arrow splide__arrow--next arrow-btn mr-3 xl:-mr-10'
                    : 'splide__arrow splide__arrow--next arrow-btn mr-[calc(-21vw/7.5)]'
                }
              >
                <Icon
                  icon="ep:arrow-up"
                  rotate={1}
                  className={isPC ? 'w-10 h-10' : 'w-[calc(28vw/7.5)] h-[calc(28vw/7.5)]'}
                />
              </button>
            </div>
            <ul className="splide__pagination mt-10"></ul>
          </Splide>
        </div>
      </div>
      <style jsx>{`
        h2 {
          text-align: center;
          font: normal normal bold calc(50vw / 7.5) Noto Sans JP;
          color: #2964b6;
        }
        h3 {
          text-align: center;
          letter-spacing: 0px;
          color: #2964b6;
          font-weight: 700;
          font-size: clamp(0px, calc(50vw / 7.5), 80px);
        }
        .arrow-btn {
          background: #003475;
          border-radius: 999px;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          width: calc(48vw / 7.5);
          height: calc(48vw / 7.5);
          transition: transform 0.15s ease-out, opacity 0.15s;
          opacity: 1;
          {
            /* cursor: pointer; */
          }
          cursor: url(getImageUrl('cursor-pointer.cur')), auto;
          
        }
        .arrow-btn:active {
          transform: scale(0.9);
          opacity: 0.8;
        }
        @media (min-width: 768px) {
          h2 {
            text-align: center;
            font: normal normal bold 80px/80px Noto Sans JP;
            color: #2964b6;
          }
          .arrow-btn {
            background: #003475;
            border-radius: 999px;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 76px;
            height: 76px;
             {
              /* cursor: pointer; */
            }d
          }
        }
      `}</style>
    </>
  )
}

export default ReasonForChoosing
